import { useToken } from "../../server/auth/use-token";
import { useClaims } from "../generic/hooks/use-claims";
import { useDesignHuddleCallback } from "./use-design-huddle-callback";
import { copyImage, imageURL } from "./utils";

import type { CommsImage } from "../template-preview/generate-comms-context";

export function useCreateDesignHuddleProjectComms(): (commsImage: CommsImage) => Promise<{
  project_id: string;
  preview_url: string;
} | null> {
  const user = useClaims();
  const getToken = useToken();

  return useDesignHuddleCallback(
    [],
    (commsImage?: CommsImage): Promise<{ project_id: string; preview_url: string } | null> => {
      if (!user || !commsImage) return Promise.resolve(null);

      return new Promise((resolve) => {
        DSHDLib.createProject(
          {
            media_type: "digital",
            template_code: commsImage.templateCode,
            customizations: commsImage.customizations,
            page_number: commsImage.pageNumber,
          },
          (err, { project_id }) => {
            if (err) {
              console.log(err);
              return resolve(null);
            }

            const dimensions =
              commsImage.imageType === "banner"
                ? { width: 1200, height: 400 }
                : { width: 1200, height: 1200 };

            DSHDLib.getVariableTemplatePreviewURL(
              {
                template_code: commsImage.templateCode,
                customizations: commsImage.customizations,
                page_number: commsImage.pageNumber,
                ...dimensions,
              },
              (previewErr, preview_url) => {
                if (previewErr) {
                  console.log(previewErr);
                  return resolve(null);
                }

                void copyImage(getToken, preview_url, project_id)
                  .then(() => {
                    resolve({
                      project_id,
                      preview_url: imageURL(user["http://changeengine.com/account_id"], project_id),
                    });
                  })
                  .catch(console.error);
              },
            );
          },
        );
      });
    },
    [user],
  );
}
